import ring from "./ring.wav";
import chatRing from "./chat-ring.mp3";
import digitalRing from "./digital-ring.mp3";
import dangRing from "./dang.mp3";
import phonenewringtone from "./phonenewringtone.mp3";
import ringbacknewtone from "./ringbacknewtone.mp3";
import { RING_TYPES } from "../../constants/constants";

interface PlayerOptions {
  type: string;
  loop?: boolean;
}

class Player {
  private audio: HTMLAudioElement;
  private type: string;
  private loop: boolean;

  constructor(options: PlayerOptions) {
    this.type = options.type;
    this.loop = options.loop || false;
    
    let sound = ring;
    switch (options.type) {
      case RING_TYPES.CALL:
        sound = phonenewringtone;
        break;
      case RING_TYPES.CHAT:
        sound = chatRing;
        break;
      case RING_TYPES.MESSAGE:
        sound = digitalRing;
        break;
      case RING_TYPES.LOGOUT_ALARM:
        sound = dangRing;
        break;
      case RING_TYPES.CALLBACK:
        sound = digitalRing;
        break;
      case RING_TYPES.CASE:
        sound = ringbacknewtone;
        break;
      default:
        sound = ring;
        break;
    }

    this.audio = new Audio(sound);
    this.audio.loop = this.loop;
  }

  play() {
    try {
      this.audio.play();
    } catch (error) {
      console.error('Error playing audio:', error);
    }
  }

  pause() {
    try {
      this.audio.pause();
    } catch (error) {
      console.error('Error pausing audio:', error);
    }
  }

  stop() {
    try {
      this.audio.pause();
      this.audio.currentTime = 0;
    } catch (error) {
      console.error('Error stopping audio:', error);
    }
  }

  setSource(source: string) {
    try {
      this.audio.src = source;
    } catch (error) {
      console.error('Error setting audio source:', error);
    }
  }

  setOutputDevice(deviceId: string) {
    try {
      this.audio.setSinkId(deviceId);
    } catch (error) {
      console.error('Error setting output device:', error);
    }
  }

  getType(): string {
    return this.type;
  }

  isLooping(): boolean {
    return this.loop;
  }
}

export default Player; 